import { ArrowRight } from "lucide-react";
import { BrutalistBadge, GlassCard } from "@/app/components/brand-scaffold";
import { Button } from "@/app/components/ui/button";

export function HomepageHeroEn() {
  return (
    <section className="relative flex items-center px-4 pt-6 sm:px-6 sm:pt-8 lg:px-8 lg:pt-10 pb-12 lg:pb-16 min-h-[calc(100svh-6rem)]">
      <div className="mx-auto w-full max-w-7xl 2xl:max-w-[1440px]">
        <div className="flex flex-col gap-7 sm:gap-9 lg:gap-11">
          <div className="flex flex-wrap gap-4 relative z-20">
            <BrutalistBadge bgClass="bg-white" hoverBgClass="hover:bg-[#3B82F6]" hoverTextClass="hover:text-white" className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]">
              OPEN PROTOCOL · LOCAL-FIRST RUNTIME
            </BrutalistBadge>
            <BrutalistBadge bgClass="bg-[#A3E635]" hoverBgClass="hover:bg-[#6366F1]" hoverTextClass="hover:text-white" className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]">
              APACHE-2.0 OPEN SOURCE
            </BrutalistBadge>
          </div>

          <div className="flex flex-col items-start gap-4 sm:gap-5">
            <h1 className="max-w-[18ch] text-[clamp(3.1rem,8vw,6rem)] font-black leading-[1.02] text-black tracking-tight text-balance">
              Private capabilities,
            </h1>
            <div className="inline-block max-w-full border-[6px] border-black bg-[#A3E635] px-5 py-3 sm:px-7 sm:py-4 shadow-[12px_12px_0px_0px_rgba(0,0,0,1)]">
              <h1 className="max-w-[18ch] text-[clamp(3.1rem,8vw,6rem)] font-black leading-[1.02] text-black tracking-tight text-balance">
                public contracts.
              </h1>
            </div>
          </div>

          <div className="grid gap-6 lg:grid-cols-[1.15fr_1fr] xl:gap-8 max-w-5xl xl:max-w-none">
            <div className="border-l-8 border-black pl-5 sm:pl-6 flex items-center">
              <p className="text-xl sm:text-2xl lg:text-[26px] xl:text-[28px] font-bold text-black leading-snug">
                Package your local scripts, workflows, models, or expertise into a Hotline. Implementation stays with you; Agents discover, call, and read standardized result_packages through a unified protocol.
              </p>
            </div>
            <GlassCard bgClass="bg-white/75" hoverClass="hover:bg-white/95" className="!p-5 sm:!p-6 flex flex-col">
              <div className="space-y-2.5 text-sm sm:text-base lg:text-[15px] font-bold text-zinc-800 leading-relaxed">
                <p>You publish contracts, not source code. Agents learn to call your contract, not peek at your implementation.</p>
                <p>CALL ANYTHING is an open protocol and local runtime for Agents to call external capabilities — not a phone tool, not a traditional comms SaaS.</p>
              </div>
            </GlassCard>
          </div>

          <div className="flex flex-wrap items-center gap-3 sm:gap-4 pt-1">
            <Button asChild variant="default" size="lg" className="max-w-full whitespace-normal text-center leading-tight sm:text-left">
              <a href="/en/docs/quick-start-responder" className="gap-2">
                Create my first Hotline
                <ArrowRight className="h-5 w-5" strokeWidth={3} />
              </a>
            </Button>
            <Button asChild variant="secondary" size="lg" className="max-w-full whitespace-normal text-center leading-tight sm:text-left">
              <a href="/en/docs/quick-start-caller">
                Call a Hotline from your Agent
              </a>
            </Button>
            <Button asChild variant="secondary" size="lg" className="max-w-full whitespace-normal text-center leading-tight sm:text-left">
              <a href="/en/docs/protocol-architecture" className="gap-2">
                Self-host options
                <ArrowRight className="h-5 w-5" strokeWidth={3} />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
